import React from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { Link, useNavigate, useParams } from 'react-router-dom';

import { PageHeader } from 'components/Page';
import { getCurrentOS, useScrollIntoView } from 'utils';

import { tabs } from '../schemas';

import * as Linux from './Linux';
import * as MacOS from './MacOS';

// TODO: add button to scroll back to top of the page

function TroubleShooting() {
  const { topic } = useParams();
  const currentOS = getCurrentOS();
  const navigate = useNavigate();
  const components = { Linux, MacOS };
  const issueRef = useScrollIntoView(topic);
  return (
    <div>
      <PageHeader
        title="TroubleShooting"
        goBack={() => navigate('/hardware/installer')}
      />
      <Tabs defaultActiveKey={currentOS} id="uncontrolled-tab-example">
        {tabs.map((tab) => (
          <Tab key={tab.key} eventKey={tab.key} title={tab.title}>
            <div className="mt-3 jumbotron">
              <ol>
                {Object.entries(components[tab.title] || {}).map(
                  ([key, value]) => (
                    <li key={key}>
                      <Link to={`/hardware/installer/troubleshooting/${key}`}>
                        {value.title}
                      </Link>
                    </li>
                  ),
                )}
              </ol>
            </div>
            {Object.entries(components[tab.title] || {}).map(([key, value]) => (
              <div key={key} id={key} ref={topic === key ? issueRef : null}>
                {value()}
              </div>
            ))}
          </Tab>
        ))}
      </Tabs>
    </div>
  );
}

export default TroubleShooting;
